import { Controller } from "stimulus"
import { formatDate, formatNumber, formatWeight } from "formatters"

export default class extends Controller {

  static values = { filter: Object, sourcePlaceTypeElement: String, sourcePlaceIdElement: String, rowsElement: String, excludeBlank: Boolean, productNameField: String }
  static get targets() {
    return ['kind', 'countrybrand', 'product', 'metal', 'goldShare', 'template', 'button', 'operationTemplate', 'operationRows', 'operationRowsContainer', 'loadRowsButton', 'excludeAlreadySelected'];
  }

  connect(){
    if (this.hasSourcePlaceTypeElementValue) {
      $(this.sourcePlaceTypeElementValue).on('change', ()=>{ this.toggleLoadButton(); });
    }
    if (this.hasSourcePlaceIdElementValue) {
      $(this.sourcePlaceIdElementValue).on('change', ()=>{ this.toggleLoadButton(); });
    }
    this.toggleLoadButton()
  }
  toggleLoadButton(){
    let disableButton = false;
    if (this.hasSourcePlaceTypeElementValue) {
      disableButton = disableButton || $(this.sourcePlaceTypeElementValue).val()=="";
    }
    if (this.hasSourcePlaceIdElementValue) {
      disableButton = disableButton || $(this.sourcePlaceIdElementValue).val()=="";
    }
    if (this.hasMetalTarget) {
      disableButton = disableButton || $(this.metalTarget).val()=="";
    }
    if (disableButton) {
      $(this.loadRowsButtonTarget).addClass('disabled');
      this.replaceOperationRows([]);      
    } else {
      $(this.loadRowsButtonTarget).removeClass('disabled');      
    }
  }
  replaceOperationRows(data) {
    let operationRowText = this.operationTemplateTarget.innerHTML;
    let container = $(this.operationRowsTarget);
    container.empty();
    if (data.length>0) {
      _.each(data, (row)=>{
        let wasSelected = _.some($('.or-source-row-id'), (source_row_el) =>{
          return $(source_row_el).val() == row.id;
        });
        let excludeAlreadySelected = this.hasExcludeAlreadySelectedTarget && $(this.excludeAlreadySelectedTarget).is(':checked');
        if (!wasSelected ||  !excludeAlreadySelected) {
          let operationRow = $(operationRowText);
          operationRow.find('.sor-operation').html(`${row.operation.kind_humanize} ${row.operation.act_or_id}`);
          operationRow.find('.sor-date').html(formatDate(row.operation.date));
          operationRow.find('.sor-product').html(row.product.fullname);
          operationRow.find('.sor-quantity').html(formatNumber(+row.quantity));
          operationRow.find('.sor-quantity-left').html(formatNumber(+row.quantity_left));
          operationRow.find('.sor-add-row').data('row', row);
          operationRow.toggleClass('bg-warning', wasSelected);
          container.append(operationRow);          
        }
      });
      $(this.operationRowsContainerTarget).removeClass('d-none');
    } else {
      $(this.operationRowsContainerTarget).addClass('d-none');      
    }
  }
  closeRows(event) {
    if (event) {
      event.preventDefault();      
    }

    let container = $(this.operationRowsTarget);
    container.empty();
    $(this.operationRowsContainerTarget).addClass('d-none');  
  }
  updateRows(event) {
    if (event) {
      event.preventDefault();      
    }

    let doLoad = true
    if (this.hasSourcePlaceTypeElementValue) {
      doLoad = doLoad && $(this.sourcePlaceTypeElementValue).val()!="";
    }
    if (this.hasSourcePlaceIdElementValue) {
      doLoad = doLoad && $(this.sourcePlaceIdElementValue).val()!="";
    }
    if (doLoad) {
      this.loadRows();
    } else {
      this.closeRows();
    }
  }
  loadRows(event) { 
    let filter = (this.hasFilterValue ? this.filterValue : {});
    if (this.hasSourcePlaceIdElementValue) {
      filter['operation_destination_place_id_eq'] = $(this.sourcePlaceIdElementValue).val();
    }
    if (this.hasSourcePlaceTypeElementValue) {
      filter['operation_destination_place_type_eq'] = $(this.sourcePlaceTypeElementValue).val();
    }
    if (this.hasKindTarget && this.kindTarget.value) {
      filter['product_kind_eq'] = this.kindTarget.value;
    }
    if (this.hasMetalTarget && this.metalTarget.value) {
      filter['product_metal_eq'] = this.metalTarget.value;
    }
    if (this.hasGoldShareTarget && this.goldShareTarget.value) {
      filter['product_gold_share_eq'] = this.goldShareTarget.value;
    }
    if (this.hasCountrybrandTarget && this.countrybrandTarget.value) {
      filter['product_product_country_brand_id_eq'] = this.countrybrandTarget.value;
    }
    $.get( "/operation_rows.json", { q: filter } )
     .done(( data )=>{
       this.replaceOperationRows(data);
     });
  }

  addProductRow(event) {
    event.preventDefault();
    let row = $(event.target).data('row');
    if (row) {
      var contentText = this.templateTarget.innerHTML.replace(/TMPL_ID/g, new Date().valueOf());
      var content = $(contentText);
      content.find('.or-source-row-id').val(row.id);
      content.find('.or-product').val(row.product_id).data('product', row.product);
      content.find('.or-product-name').html(row.product.fullname);
      if (row.quantity) {
        let quantity = +row.quantity_left;
        let productGrossweight = +row.product.gross_weight;
        if (productGrossweight==0) productGrossweight = 1;
        let productNetweight = +row.product.net_weight;
        if (productNetweight==0) productNetweight = 1;
        let grossweight = quantity*productGrossweight;
        let netweight = quantity*productNetweight;
        $(this.grossweightTarget).html(formatWeight(grossweight));
        $(this.element).find('.or-gross-weight').val(grossweight);
        $(this.netweightTarget).html(formatWeight(netweight));
        $(this.element).find('.or-net-weight').val(netweight);
        content.find('.or-quantity').val(quantity);
        content.find('.or-gross-weight').val(+grossweight);
        content.find('.or-gross-weight-label').html(formatWeight(+grossweight));
        content.find('.or-net-weight').val(+netweight);
        content.find('.or-net-weight-label').html(formatWeight(+netweight));
      }
      if (row.price) {
        content.find('.or-price').val(+row.price);
        if (row.quantity) {
          content.find('.or-total').val(+row.price * +row.quantity_left);
        }
      }
      $(this.rowsElementValue).append(content);
      // content.find('.or-quantity').focus();
      if (row.quantity) {
        content.find('.or-quantity').trigger('change');
        let odivUpdateEvent = new CustomEvent("odiv-update");
        window.dispatchEvent(odivUpdateEvent);
      }
      $(event.target).closest('tr').hide();
    }
  }
}